import {JsToClientCommand} from '../jsToClientCommand';
import {ClientCommands} from '../clientCommands';

export type SetFacebookAccessTokenCommandParams = {
    accessToken: string
};

export class SetFacebookAccessTokenCommand extends JsToClientCommand<SetFacebookAccessTokenCommandParams> {
    constructor(params: SetFacebookAccessTokenCommandParams) {
        super(ClientCommands.SET_FACEBOOK_ACCESS_TOKEN, params);
    }
}
